module.exports = __webpack_public_path__ + "img/knight4_01.63961296.jpg";